import React, { Suspense } from "react";
import {Routes, Route} from "react-router-dom";
import routeConfig from "./index";

const MainRouter = ({categoriesList, categoriesError}) => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                <Route>
                    {routeConfig.map(route =>
                        <Route
                            key={route.path}
                            path={route.path}
                            element={React.cloneElement(route.element, {categoriesList, categoriesError})}
                        />
                    )}
                </Route>
            </Routes>
        </Suspense>
    )
}

export default MainRouter;